import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d9b80bea"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "modal" };
const _hoisted_2 = { class: "field" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "brand" }, [
    /*#__PURE__*/ _createTextVNode("ブランド"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    selected: ""
}, "未選択", -1));
const _hoisted_5 = ["value"];
const _hoisted_6 = { class: "field" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "store" }, [
    /*#__PURE__*/ _createTextVNode("付与店舗"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    selected: ""
}, "未選択", -1));
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "field" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "point_name" }, [
    /*#__PURE__*/ _createTextVNode("ポイント名"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_12 = { class: "field" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "point_grant_reason" }, "詳細説明", -1));
const _hoisted_14 = { class: "field" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "points" }, [
    /*#__PURE__*/ _createTextVNode("付与ポイント数"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_16 = {
    key: 0,
    class: "field"
};
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "effective_period_date" }, [
    /*#__PURE__*/ _createTextVNode("有効期限"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_18 = { style: { "display": "flex" } };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { style: { "font-size": "20px" } }, "日", -1));
const _hoisted_20 = { class: "button-row" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Title = _resolveComponent("Title");
    return ($props.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "overlay",
            onMousedown: _cache[8] || (_cache[8] = _withModifiers(
            //@ts-ignore
            (...args) => ($options.close && $options.close(...args)), ["self"]))
        }, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, [
                    _createVNode(_component_Title, {
                        msg: "ポイント設定",
                        submsg: "Point Setting"
                    })
                ]),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        _withDirectives(_createElementVNode("select", {
                            id: "brand",
                            name: "brand",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($data.form.brand) = $event))
                        }, [
                            _hoisted_4,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.brandInfo, (b) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: b.brandId,
                                    value: b
                                }, _toDisplayString(b.brandName), 9, _hoisted_5));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, $data.form.brand]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _withDirectives(_createElementVNode("select", {
                            id: "store",
                            name: "store",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($data.form.store) = $event))
                        }, [
                            _hoisted_8,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.storeInfo, (s) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: s.storeId,
                                    value: s
                                }, _toDisplayString(s.storeName), 9, _hoisted_9));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, $data.form.store]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "point_name",
                            name: "point_name",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($data.form.point_name) = $event))
                        }, null, 512), [
                            [_vModelText, $data.form.point_name]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _withDirectives(_createElementVNode("textarea", {
                            id: "point_grant_reason",
                            name: "point_grant_reason",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($data.form.point_grant_reason) = $event))
                        }, null, 512), [
                            [_vModelText, $data.form.point_grant_reason]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "points",
                            name: "points",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($data.form.points) = $event))
                        }, null, 512), [
                            [_vModelText, $data.form.points]
                        ])
                    ]),
                    (!$options.isDeductionMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("div", _hoisted_18, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    id: "effective_period_date",
                                    name: "effective_period_date",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (($data.form.effective_period_date) = $event))
                                }, null, 512), [
                                    [_vModelText, $data.form.effective_period_date]
                                ]),
                                _hoisted_19
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                        class: "btn-back",
                        onClick: _cache[6] || (_cache[6] =
                            //@ts-ignore
                            (...args) => ($options.close && $options.close(...args)))
                    }, "戻る"),
                    _createElementVNode("button", {
                        class: "btn-setting",
                        onClick: _cache[7] || (_cache[7] =
                            //@ts-ignore
                            (...args) => ($options.handleSetting && $options.handleSetting(...args)))
                    }, "ポイント設定")
                ])
            ])
        ], 32))
        : _createCommentVNode("", true);
}
